import { render, staticRenderFns } from "./serviceComponent.vue?vue&type=template&id=5b66e490"
import script from "./serviceComponent.vue?vue&type=script&lang=js"
export * from "./serviceComponent.vue?vue&type=script&lang=js"
import style0 from "./serviceComponent.vue?vue&type=style&index=0&id=5b66e490&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports